import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import CurrencyComponent from '../CurrencyComponent';

const ProductItem = ({
  product,
  index,
  onRemove,
  onUpdate,
  onMoveUp,
  onMoveDown,
  canMoveUp,
  canMoveDown,
  prestationType,
}) => {
  // État local pour gérer la valeur du prix
  const [priceValue, setPriceValue] = useState(product.price || 0);
  useEffect(() => {
    setPriceValue(product.price || 0);
  }, [product.price]);

  const handleQuantityChange = (e) => {
    const quantity = e.target.value <= 0 ? 1 : e.target.value;
    onUpdate({ ...product, quantity: quantity }, index);
  };

  const handlePriceChange = (value) => {
    const price = value;
    setPriceValue(value);
    onUpdate({ ...product, price: price }, index);
  };

  const productName = product?.renammed 
  ?? (prestationType === 'caterer' && product?.catererName 
      ? product.catererName 
      : product.name);

  return (
    <Row key={index} className="my-2">
      <Col xs={12} sm={3} md={2}>
        <Form.Control
          type="number"
          value={product.quantity}
          onChange={handleQuantityChange}
          step="0.01"
        />
      </Col>
      <Col xs={12} sm={3} md={3}>
        <CurrencyComponent
          initialPrice={priceValue}
          onPriceChange={handlePriceChange}
        />
      </Col>
      <Col xs={12} sm={4} md={4}>
        <Form.Control type="text" value={
          (!product?.product_id && !product?.product_part_id)
            ? `${productName} (élément supprimé)`
            : productName
        } readOnly />
      </Col>
      <Col xs={12} sm={2} md={3}>
        <div style={{ display: "flex", gap: "3px", flexWrap: "wrap" }}>
          {onMoveUp && (
            <Button 
              variant="outline-secondary" 
              size="sm"
              onClick={onMoveUp}
              disabled={!canMoveUp}
              title="Déplacer vers le haut"
            >
              <FontAwesomeIcon icon={faArrowUp} />
            </Button>
          )}
          {onMoveDown && (
            <Button 
              variant="outline-secondary" 
              size="sm"
              onClick={onMoveDown}
              disabled={!canMoveDown}
              title="Déplacer vers le bas"
            >
              <FontAwesomeIcon icon={faArrowDown} />
            </Button>
          )}
          <Button variant="outline-danger" size="sm" onClick={() => onRemove(index)} title="Supprimer">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default ProductItem;
